import styled from 'react-emotion';
import { Price } from '../Price';
import MaxWidth from '../Layout/MaxWidth';

const Container = styled(MaxWidth)`
  margin-bottom: ${({ theme }) => theme.sizes[10]};
  ${({ theme }) => theme.below.md} {
    margin-bottom: ${({ theme }) => theme.sizes[4]};
  }
`;

const ContainerInner = styled('div')`
  //max-width: 1136px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  max-width: 100%;
`;

const Heading = styled('h1')`
  font-weight: bold;
  ${({ theme }) => theme.typography.h1}
  margin-bottom: 12px;
  font-size: 2.5rem;
  line-height: 3.15rem;
  max-width: 100%;
`;

const SubHeading = styled('h2')`
  margin-bottom: 10px;
`;

const ArticleNumber = styled('p')`
  line-height: 23px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: 20px !important;
  > span {
    &:first-of-type {
      text-transform: uppercase;
    }
    &:last-of-type {
      color: ${({ theme }) => theme.colors.themeGreyDark};
      margin-left: 0.5rem;
    }
  }
`;

const ShortDescription = styled('article')`
  line-height: 1.75;
  font-size: 0.875rem;
  margin-bottom: 1rem;

  p {
    margin-bottom: 1rem;
  }
`;

const ProductContainer = styled('div')`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 1rem;
  ${({ theme }) => theme.below.md} {
    padding-top: 0;
  }
`;

const ProductDetailsWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${Price.Wrapper} {
    display: flex;
    margin-bottom: 2rem;
    font-size: 1.75rem;
    font-weight: bold;
  }
  ${Price.Normal} {
  }
  ${Price.New} {
    color: ${({ theme }) => theme.colors.themeRed};
    order: 2;
    margin-left: 0.875rem;
  }
  ${Price.Old} {
    order: 1;
    position: relative;
    text-decoration: none;
    opacity: 0.4;
    &:after {
      content: '';
      height: 3px;
      width: calc(100% + 12px);
      position: absolute;
      top: 50%;
      left: -5px;
      right: 0;
      transform: translateY(-50%);
      background: ${({ theme }) => theme.colors.black};
    }
  }
`;

export {
  Container,
  ContainerInner,
  Heading,
  SubHeading,
  ArticleNumber,
  ShortDescription,
  ProductContainer,
  ProductDetailsWrapper
};
